export enum OfferBadgeEnum {
  ExtrasAvailable = 'Dostępne dodatki',
  RecommendedOffer = 'Polecana oferta',
  RenewalOffer = 'Twoje odnowienie',
  YourOffer = 'Twoja oferta',
}
